import { State } from '.';
import { CounselingType } from '../../models/counseling-type';

export const selectors = {
    getCounselingType: (
        state: State,
        id: Undefinable<number>
    ): Undefinable<CounselingType> => state.byId[id || ''],
    getCounselingTypeIds: (
        state: State
    ): number[] => state.allIds
};
